import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { group } from 'd3-array';
import { subObject } from '../utils/helper';
import { mergeState, selectG2Elements, useState, createValueof, createDatumof } from './utils';
import { markerOf, labelOf, itemsOf, legendsOf, dataOf } from './legendFilter';
export function LegendHighlight() {
  return function (context, _, emitter) {
    var container = context.container,
      view = context.view,
      options = context.options;
    var legends = legendsOf(container);
    var elements = selectG2Elements(container);
    var channelOf = function channelOf(legend) {
      return dataOf(legend).scales[0].name;
    };
    var scaleOf = function scaleOf(channel) {
      var scale = view.scale[channel];
      return scale;
    };
    var markState = mergeState(options, ['active', 'inactive']);
    var valueof = createValueof(elements, createDatumof(view));
    var destroys = [];
    // Bind events for each legend.
    var _iterator = _createForOfIteratorHelper(legends),
      _step;
    try {
      var _loop = function _loop() {
        var legend = _step.value;
        var datumOf = function datumOf(item) {
          var data = legend.attributes.data;
          var datum = item.__data__;
          var index = datum.index;
          return data[index].label;
        };
        var channel = channelOf(legend);
        var items = itemsOf(legend);
        var scale = scaleOf(channel);
        var elementGroup = group(elements, function (d) {
          return scale.invert(d.__data__[channel]);
        });
        var _legend$attributes$st = legend.attributes.state,
          legendState = _legend$attributes$st === void 0 ? {} : _legend$attributes$st;
        var _legendState$inactive = legendState.inactive,
          inactive = _legendState$inactive === void 0 ? {} : _legendState$inactive;
        var _useState = useState(markState, valueof),
          setState = _useState.setState,
          removeState = _useState.removeState; // Handle styles of inner item.
        var markerStyle = {
          inactive: subObject(inactive, 'marker')
        };
        var labelStyle = {
          inactive: subObject(inactive, 'label')
        };
        var _useState2 = useState(markerStyle),
          setM = _useState2.setState,
          removeM = _useState2.removeState;
        var _useState3 = useState(labelStyle),
          setL = _useState3.setState,
          removeL = _useState3.removeState;
        var updateLegendState = function updateLegendState(highlight) {
          var _iterator2 = _createForOfIteratorHelper(items),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item = _step2.value;
              var marker = markerOf(item);
              var label = labelOf(item);
              if (item === highlight || highlight === null) {
                removeM(marker, 'inactive');
                removeL(label, 'inactive');
              } else {
                setM(marker, 'inactive');
                setL(label, 'inactive');
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        };
        var highlightItem = function highlightItem(event, item) {
          // Update UI.
          var value = datumOf(item);
          var elementSet = new Set(elementGroup.get(value));
          var _iterator3 = _createForOfIteratorHelper(elements),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var e = _step3.value;
              if (elementSet.has(e)) setState(e, 'active');else setState(e, 'inactive');
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          updateLegendState(item);
          // Emit events.
          var _event$nativeEvent = event.nativeEvent,
            nativeEvent = _event$nativeEvent === void 0 ? true : _event$nativeEvent;
          if (!nativeEvent) return;
          emitter.emit('legend:highlight', Object.assign(Object.assign({}, event), {
            nativeEvent: nativeEvent,
            data: {
              channel: channel,
              value: value
            }
          }));
        };
        var itemPointerover = new Map();
        // Add listener for the legend items.
        var _iterator4 = _createForOfIteratorHelper(items),
          _step4;
        try {
          var _loop2 = function _loop2() {
            var item = _step4.value;
            var pointerover = function pointerover(event) {
              highlightItem(event, item);
            };
            item.addEventListener('pointerover', pointerover);
            itemPointerover.set(item, pointerover);
          };
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            _loop2();
          }
          // Add listener for the legend group.
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        var pointerleave = function pointerleave(event) {
          var _iterator5 = _createForOfIteratorHelper(elements),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var e = _step5.value;
              removeState(e, 'inactive', 'active');
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
          updateLegendState(null);
          // Emit events.
          var _event$nativeEvent2 = event.nativeEvent,
            nativeEvent = _event$nativeEvent2 === void 0 ? true : _event$nativeEvent2;
          if (!nativeEvent) return;
          emitter.emit('legend:unhighlight', {
            nativeEvent: nativeEvent
          });
        };
        var onHighlight = function onHighlight(event) {
          var nativeEvent = event.nativeEvent,
            data = event.data;
          if (nativeEvent) return;
          var specifiedChannel = data.channel,
            value = data.value;
          if (specifiedChannel !== channel) return;
          var item = items.find(function (d) {
            return datumOf(d) === value;
          });
          if (!item) return;
          highlightItem({
            nativeEvent: false
          }, item);
        };
        var onUnHighlight = function onUnHighlight(event) {
          var nativeEvent = event.nativeEvent;
          if (nativeEvent) return;
          pointerleave({
            nativeEvent: false
          });
        };
        legend.addEventListener('pointerleave', pointerleave);
        emitter.on('legend:highlight', onHighlight);
        emitter.on('legend:unhighlight', onUnHighlight);
        var destroy = function destroy() {
          legend.removeEventListener(pointerleave);
          emitter.off('legend:highlight', onHighlight);
          emitter.off('legend:unhighlight', onUnHighlight);
          var _iterator6 = _createForOfIteratorHelper(itemPointerover),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _step6$value = _slicedToArray(_step6.value, 2),
                item = _step6$value[0],
                pointerover = _step6$value[1];
              item.removeEventListener(pointerover);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
        };
        destroys.push(destroy);
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return function () {
      return destroys.forEach(function (d) {
        return d();
      });
    };
  };
}